module.exports = __webpack_public_path__ + "RemoveLabels.425b8e589b39305636bf2e6cfb085dfc.svg";